/* Insect Insane — specimen image gallery

   Adds previous/next navigation to any .ii-zoom container that carries a
   [data-gallery-data] JSON list of images.

   It swaps the src of the single existing [data-zoom-image] rather than
   stacking several images, because the click-to-zoom behaviour in theme.js
   binds to the first [data-zoom-image] it finds and transforms only that
   element. One image in the DOM keeps zoom working on every frame. */
(function () {
  'use strict';

  if (window.IIGalleryReady) return;
  window.IIGalleryReady = true;

  function setup(node) {
    if (node.dataset.galleryReady) return;

    var holder = node.querySelector('[data-gallery-data]');
    var image = node.querySelector('[data-zoom-image]');
    if (!holder || !image) return;

    var items;
    try {
      items = JSON.parse(holder.textContent);
    } catch (error) {
      return;
    }
    if (!items || items.length < 2) return;

    node.dataset.galleryReady = 'true';

    var counter = node.querySelector('[data-gallery-count]');
    var index = 0;

    /* Warm the cache so stepping through the frames does not flash. */
    items.forEach(function (item) {
      var preload = new Image();
      preload.src = item.src;
    });

    function show(next) {
      index = (next + items.length) % items.length;
      image.removeAttribute('srcset');
      image.src = items[index].src;
      if (items[index].alt) image.alt = items[index].alt;
      if (counter) counter.textContent = index + 1 + ' / ' + items.length;
      /* theme.js hangs a reset() on the container once zoom is initialised. */
      if (typeof node.reset === 'function') node.reset();
    }

    function bind(selector, step) {
      var button = node.querySelector(selector);
      if (!button) return;
      /* The container toggles zoom on click and tracks pointer drags, so both
         events have to stop here or every arrow press also zooms the plate. */
      button.addEventListener('pointerdown', function (event) {
        event.stopPropagation();
      });
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        show(index + step);
      });
    }

    bind('[data-gallery-prev]', -1);
    bind('[data-gallery-next]', 1);
  }

  function scan() {
    var nodes = document.querySelectorAll('.ii-zoom');
    for (var i = 0; i < nodes.length; i++) setup(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);

  /* Arrow keys step through the frames while a specimen card is open. On the
     product page they are left alone so they still scroll. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    var modal = document.querySelector('[data-specimen-modal]:not([hidden])');
    if (!modal) return;
    var button = modal.querySelector(
      event.key === 'ArrowLeft' ? '[data-gallery-prev]' : '[data-gallery-next]'
    );
    if (!button) return;
    event.preventDefault();
    button.click();
  });
})();
